import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'eastern_metal_building',
} as IModuleProps;
